import { StyledContent } from '@/components/styles'
import { PreviewLinks } from '@/components'

const TitleContentDirections = ({ data }) => {
  const { content: htmlContent, directions } = data

  return (
    <>
      {htmlContent && (
        <StyledContent.Description>
          <StyledContent.Html dangerouslySetInnerHTML={{ __html: htmlContent }} />
        </StyledContent.Description>
      )}

      {Object.keys(directions).length > 0 && (
        <PreviewLinks data={directions} linksType="direction" />
      )}
    </>
  )
}

export default TitleContentDirections
